import * as React from "react";
import Emojify from "~/components/shared/Emojify";
import classNames from "classnames";

type Variant = "default" | "blue-gradient" | "orange-gradient";

type Props = {
  heading: string;
  subheading?: React.ReactNode;
  emoji?: string;
  fullscreen?: boolean;
  variant?: Variant;
  link?: React.ReactNode;
  rounded?: boolean;
  pulse?: boolean;
};

export default function EmptyState(props: Props) {
  const { variant = "default", rounded = true, pulse = false } = props;

  const variantStyles: Record<Variant, string> = {
    default: "bg-slate-100",
    "blue-gradient": "bg-empty-state-blue-gradient",
    "orange-gradient": "bg-empty-state-orange-gradient",
  };

  return (
    <div
      className={classNames(
        "relative flex min-h-[160px] flex-col items-center justify-center gap-5 p-5 antialiased",
        rounded ? "rounded-3" : "",

        variantStyles[variant],
        props.fullscreen ? "h-full" : "h-auto",
      )}
    >
      {props.emoji && (
        <span className="ui-emoji">
          <Emojify
            text={props.emoji}
            style={{ fontSize: 38, lineHeight: 1 }}
            title={props.heading}
          />
        </span>
      )}

      <div
        className={classNames(
          "flex flex-col items-center justify-center gap-2.5",
          pulse ? "animate-pulse" : "",
        )}
      >
        <h3 className="m-0 text-center text-lg">{props.heading}</h3>
        {props.subheading && <p className="m-0 max-w-[360px] text-center">{props.subheading}</p>}
      </div>
      {props.link}
    </div>
  );
}
